import { createAsyncThunk } from '@reduxjs/toolkit';

import { sendSongsSuggestion } from 'services/networking/songs';

type FetchSongsSuggestionPayload = boolean;
type FetchSongsSuggestionParams = string;

export const fetchSongsSuggestion = createAsyncThunk<
  FetchSongsSuggestionPayload,
  FetchSongsSuggestionParams
>('songSuggestions/fetch', async (suggestion: string) => {
  const response = await sendSongsSuggestion(suggestion);
  return response;
});
